const x = (t) => {
  let r = [];
  return Array.from(t.querySelectorAll("title")).forEach((o) => {
    const i = document.head.querySelector("title");
    i ? document.head.replaceChild(o, i) : document.head.append(o);
  }), Array.from(t.querySelectorAll("meta")).forEach((o) => {
    const i = o.getAttribute("name"), a = o.getAttribute("property");
    if (i || a) {
      const n = document.head.querySelectorAll(`meta[name="${i}"]`), u = document.head.querySelectorAll(`meta[property="${a}"]`);
      n != null && n[0] ? document.head.replaceChild(o, n[0]) : u != null && u[0] ? document.head.replaceChild(o, u[0]) : document.head.append(o);
    } else
      document.head.append(o);
  }), Array.from(t.querySelectorAll("link, style")).forEach((o) => {
    const i = (a) => new Promise((n) => {
      if (a instanceof HTMLLinkElement && a.href && !a.onload && a.rel == "stylesheet") {
        const u = document.createElement("link");
        Array.from(a.attributes).forEach((g) => {
          u.setAttribute(g.name, g.value);
        }), u.onload = () => n(!0), u.onerror = () => {
          console.error(`Failed to load CSS file: ${u.href}`), n(!1);
        }, document.head.append(u), a.remove();
      } else
        document.head.append(a), n(!0);
    });
    r.push(() => i(o));
  }), Y(r).then(() => {
  }).catch((o) => console.error(o));
}, A = async (t, r) => {
  var o = Z(t), i = o.filter((n) => n.hasAttribute("priority"));
  console.debug("Priority Scripts:", i);
  var a = o.filter((n) => !n.hasAttribute("priority"));
  console.debug("Unsorted Scripts:", a);
  for (const n of i)
    await new Promise((u) => {
      q(n, r, u);
    });
  await Promise.all(
    a.map(
      (n) => new Promise((u) => {
        q(n, r, u);
      })
    )
  );
}, q = (t, r, o) => {
  var i, a;
  if ((i = t.innerHTML) != null && i.includes("document.write"))
    console.error("Error: Unable to reprocess this script tag as it contains a 'document.write()' call.", t), typeof o == "function" && o();
  else
    try {
      const n = document.createElement("script");
      Array.from(t.attributes).forEach((g) => {
        n.setAttribute(g.name, g.value);
      });
      const u = document.createTextNode(t.innerHTML);
      if (n.appendChild(u), typeof o == "function") {
        const g = n.src, $ = n.type;
        g && $ !== "text/plain" && (g.startsWith("http://") || g.startsWith("https://") || g.startsWith("//")) ? (n.onload = () => o(), n.onerror = () => {
          console.error(`Failed to load script: ${n.src}`), o();
        }) : setTimeout(o, 0);
      }
      t.parentNode ? (a = t.parentNode) == null || a.replaceChild(n, t) : document.body.replaceChild(n, t), typeof r == "function" && (r == null || r(t, n));
    } catch (n) {
      console.error("Error: Unable to reprocess this script tag.", n, t), typeof o == "function" && o();
    }
}, Y = (t) => t.reduce((r, o) => r.then(
  (i) => o().then((a) => [...i, a])
), Promise.resolve([])), Z = (t) => Array.from(t.querySelectorAll("script")).sort((i, a) => {
  const n = parseInt(i.getAttribute("priority") ?? "Infinity"), u = parseInt(a.getAttribute("priority") ?? "Infinity");
  return n - u;
}), W = (t) => {
  const i = decodeURIComponent(document.cookie).split("; ").find((a) => a.startsWith(`${t}=`));
  return i == null ? void 0 : i.split(`${t}=`)[1];
}, re = {
  parseMetaData: x,
  parseScriptTagsAsync: A,
  getCookie: W
}, B = "6657193977244c13", D = "x-d-token", F = () => W("reese84"), G = (t) => {
  var r;
  return (t == null ? void 0 : t.status) == 405 || (t == null ? void 0 : t.status) == 0 || typeof (t == null ? void 0 : t.data) == "string" && ((r = t == null ? void 0 : t.data) == null ? void 0 : r.includes("<title>Pardon Our Interruption</title>"));
}, O = (t) => {
  var r;
  if (t) {
    let o = document.getElementById("imperva-challenge");
    o && ((r = o.parentNode) == null || r.removeChild(o)), o = document.createElement("div"), o.id = "imperva-challenge";
    const i = {
      color: "#000",
      background: "#fff",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: 999999,
      overflow: "hidden"
    };
    Object.assign(o.style, i);
    let a = (t == null ? void 0 : t.data) || "";
    t != null && t.challengeUrl && (a = a.replace(`/${B}`, t == null ? void 0 : t.challengeUrl)), o.innerHTML = a, document.body.appendChild(o), A(o);
  } else
    alert("An error occured while loading. Please refresh your page and try again."), console.error("No challenge response to render.");
}, R = (t) => {
  let r = !1;
  if ((t != null && t.data || t != null && t.status) && (r = !0), !t || r && G(t)) {
    O(t);
    return;
  }
  return t;
}, oe = {
  tokenHeaderName: D,
  getToken: F,
  isChallengeRequest: G,
  renderChallengeResponse: O,
  analyzeResponse: R
}, ee = {
  enabled: !1,
  debug: !1,
  forceBeta: !1,
  forceImpervaScript: !1,
  betaCookieName: "SH_UseBetaSite",
  useLegacyRoutes: !0,
  legacySlug: "/inventory/",
  elementId: "inventory-wrapper",
  errorRoute: "/notfound.html"
}, ne = (t = {}) => {
  const r = { ...ee, ...t }, o = "/HostedBilling/Invoice/", i = (e = !0) => r.enabled = e === !0, a = () => n().isInternal ? "DEVELOPMENT" : F(), n = () => {
    const e = window.location.hostname, s = {
      hostName: e,
      isInternal: !1,
      subdomain: L() ? "beta." : "www."
    }, m = ["sandhillsdemo4", "sandhillsdemo11"];
    return e.endsWith(".hdev") || e.endsWith(".hdsdev") || e.endsWith(".wpdev") ? (s.isInternal = !0, m.some((p) => e.includes(p)) && (s.subdomain = `dev1.${L() ? "beta." : ""}`)) : (e.endsWith(".hstg") || e.endsWith(".hdsstg") || e.endsWith(".wpstg")) && (s.isInternal = !0, m.some((p) => e.includes(p)) && (s.subdomain = `stg1.${L() ? "beta." : ""}`)), s;
  }, u = () => window.location.hostname.startsWith("stg."), g = () => window.location.hostname.endsWith("--hstg.sandhillsdemo.com") || window.location.hostname.endsWith("--wpstg.sandhillsdemo.com"), $ = () => n().subdomain, L = () => {
    const e = W(r.betaCookieName);
    return (e == null ? void 0 : e.toLowerCase()) === "true" || e == "1";
  }, V = () => `https://${$()}sandhillsinventory.com`, E = () => {
    let e = "";
    const s = decodeURIComponent(window.location.search);
    if (s.startsWith("?/")) {
      let m = window.location.search.slice(1), p = m.includes("%3F") ? "%3F" : "?", [S, ...d] = m.split(p), y = d.length ? "?" + d.join("?") : "";
      e = decodeURIComponent(S) + y;
    } else
      s.startsWith("?Payment") ? e = o : (window.location.pathname.startsWith("/listing") || window.location.pathname.startsWith("/parts") || window.location.pathname.startsWith("/job-listings")) && (e = `${window.location.pathname}${window.location.search}`);
    return e;
  }, M = (e) => r.useLegacyRoutes ? `${r.legacySlug}?${e}` : e, z = (e) => {
    const s = e ?? E();
    if (!s.startsWith("/"))
      return console.error(`Invalid URL: ${s}`), window.location.href = r.errorRoute, new URL(r.errorRoute);
    const m = s.includes("?") ? "&" : "?";
    return new URL(`${V()}${s}${m}${N()}`);
  }, N = () => `exload=1&hostedDomain=${window.location.hostname}`, K = () => {
    const e = document.getElementById(r.elementId);
    return e || console.error(`Unable to find element on the page with id: ${r.elementId}`), e;
  }, _ = (e) => {
    if (!r.enabled)
      throw new Error("SandhillsHostedSites is not enabled. Please call the .enable() method.");
    const s = z(e || void 0), m = K();
    if (m) {
      m.style.height = "0", m.style.overflow = "hidden", m.style.visibility = "hidden";
      const p = new Headers(), S = a();
      S && p.append(D, S), w("InvResponseStarted"), l(""), l("****** Loading Inventory ******"), fetch(s.href, {
        mode: "cors",
        headers: p
      }).then(async (d) => {
        var c;
        l(`Response Time: ${(c = v("InvResponseTime", "InvResponseStarted")) == null ? void 0 : c.duration}ms`);
        var y = await d.text();
        const b = R({ status: d.status, data: y, challengeUrl: U });
        return {
          htmlResponse: (b && y) ?? "",
          fetchResponse: d
        };
      }).then(async (d) => {
        var y, b, P, c, I;
        if (d)
          if (d.htmlResponse.startsWith("/"))
            window.location.href = M(d.htmlResponse);
          else {
            if (w("InvDocStarted"), w("InvHtmlParseStarted"), g() && (d.htmlResponse += '<meta name="robots" content="noindex, nofollow">'), m.innerHTML = d.htmlResponse, l(`Parse Html Time: ${(y = v("InvHtmlParseTime", "InvHtmlParseStarted")) == null ? void 0 : y.duration}ms`), w("InvMetaParseStarted"), await x(m), l(`Parse Meta Time: ${(b = v("InvMetaParseTime", "InvMetaParseStarted")) == null ? void 0 : b.duration}ms`), w("InvScriptParseStarted"), k("Script Details"), await A(m, (h, f) => {
              l(`   - Script: ${h.hasAttribute("src") ? h.getAttribute("src") : h.innerText.substring(0, 100)}`), l(`     - Executed At: ${(/* @__PURE__ */ new Date()).toISOString()}`, { oldEl: h, newEl: f });
            }), j(), l(`Parse Scripts Time: ${(P = v("InvScriptParseTime", "InvScriptParseStarted")) == null ? void 0 : P.duration}ms`), !s.href.includes(o)) {
              const h = s.href !== d.fetchResponse.url;
              let f = M(e || E());
              if (h) {
                l(`Redirected to: ${d.fetchResponse.url}`);
                const C = new URL(d.fetchResponse.url);
                let T = C.pathname + C.search;
                const X = T.includes("?") ? "&" : "?";
                T = T.replace(`${X}${N()}`, ""), f = M(T);
              }
              history.replaceState(s.search, "", f);
            }
            m.style.height = "", m.style.overflow = "", m.style.visibility = "", (c = document.getElementById("lds")) == null || c.remove(), l(`Doc Time: ${(I = v("InvDocTime", "InvDocStarted")) == null ? void 0 : I.duration}ms`), setTimeout(function() {
              if (window.MediaController) {
                l("** Temp patch for Media Control Window Load events: v1"), window.MediaController.Instances.loadComplete = !0, l(`Media Controller Instances: ${window.MediaController.Instances.length}`);
                for (var h = 0, f = window.MediaController.Instances.length; h < f; h++)
                  l(`Adjusting Media Controller Index: ${h}`), window.MediaController.Instances[h].thumbnails.alignThumbStrip(), window.MediaController.Instances[h].currentItem.loadRegImg();
              }
            }, 500);
          }
      }).catch(() => {
        R();
      });
    }
  }, J = () => {
    if (!r.enabled)
      throw new Error("SandhillsHostedSites is not enabled. Please call the .enable() method.");
    const e = new Headers(), s = a();
    s && e.append(D, s), w("LayoutResponseStarted"), l("****** Loading Layout ******");
    const m = `/InventoryLayout.htm${window.location.search}`;
    fetch(m, {
      headers: e
    }).then(async (p) => {
      var y;
      l(`Response Time: ${(y = v("LayoutResponseTime", "LayoutResponseStarted")) == null ? void 0 : y.duration}ms`);
      var S = await p.text();
      const d = R({ status: p.status, data: S, challengeUrl: U });
      return d && S;
    }).then(async (p) => {
      var S, d, y, b;
      if (p) {
        const P = new URLSearchParams(window.location.search);
        w("LayoutHtmlReplacementStarted");
        let c = p;
        c = c.replace("##TITLE##", P.get("title") ?? ""), c = c.replace("<!--##REPLACE##-->", `${Q()}<div id="inventory-wrapper"></div>`), c = c.replace("</head>", "<!-- Google Tag Manager --><script>(function(w, d, s, l, i){w[l]=w[l] || []; w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'}); var f=d.getElementsByTagName(s)[0], j=d.createElement(s), dl=l !='dataLayer' ? '&l=' + l : ''; j.async=true; j.src='https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);})(window, document, 'script', 'dataLayer', 'GTM-N6K7FFV');<\/script><!-- End Google Tag Manager --> </head>"), c = c.replace("<body>", "<body> <!-- Google Tag Manager (noscript) --><noscript> <iframe src='https://www.googletagmanager.com/ns.html?id=GTM-N6K7FFV' height='0' width='0' style='display: none; visibility: hidden'></iframe></noscript><!-- End Google Tag Manager (noscript) -->"), c = c.replace(/(<body[^>]*>[\s\S]*?<\/body>)/gi, (h) => h.replace(/<script\b[^>]*\bsrc="[^"]*"[^>]*>/gi, (f) => f.replace(/<script(.*?)>/, '<script$1 priority="3">'))), c = c.replace(/(<body[^>]*>)([\s\S]*?)(<script.*?>)/, (h, f, C, T) => `${f}${H()}${C}${T}`), c.includes(H()) || (c = c.replace(/(<\/body>)/, `${H()}$1`)), c = c.replace("</body>", "</body> <!-- Loaded from [sandhills-imperva-ajax > loadLayout] (v0.1.40) -->"), l(`Html Replacement Time: ${(S = v("LayoutHtmlReplacementTime", "LayoutHtmlReplacementStarted")) == null ? void 0 : S.duration}ms`);
        const I = document.querySelector("html");
        I && (w("LayoutDocStarted"), I.style.display = "none", I.innerHTML = c, w("LayoutMetaParseStarted"), await x(I), l(`Parse Meta Time: ${(d = v("LayoutMetaParseTime", "LayoutMetaParseStarted")) == null ? void 0 : d.duration}ms`), I.style.display = "", w("LayoutScriptParseStarted"), k("Script Details"), await A(I, (h, f) => {
          l(`   - Script: ${h.hasAttribute("src") ? h.getAttribute("src") : h.innerText.substring(0, 100)}`), l(`     - Executed At: ${(/* @__PURE__ */ new Date()).toISOString()}`, { oldEl: h, newEl: f });
        }), j(), l(`Parse Scripts Time: ${(y = v("LayoutScriptParseTime", "LayoutScriptParseStarted")) == null ? void 0 : y.duration}ms`), l(`Doc Time: ${(b = v("LayoutDocTime", "LayoutDocStarted")) == null ? void 0 : b.duration}ms`));
      }
    }).catch(() => {
      R();
    });
  }, H = () => {
    let e = "";
    return (r.forceImpervaScript && !n().isInternal || u()) && (e += `<script src='${U}' priority='0'><\/script>`), e += `<script src='${r.relativeResourcePath}js/sandhills-imperva-ajax.umd.js?v=0.1.40'><\/script>`, e += "<!-- Need for HS to have access to jQuery -->", e += `<script src='https://${$()}sandhillsinventory.com/bundles/common?v=NoCache' priority='1'><\/script>`, e += `<script src='https://${$()}sandhillsinventory.com/bundles/react?v=NoCache' priority='2'><\/script>`, e += "<script>", e += " setTimeout(() => {", e += `   window.sandhillsHostedSites = window.sandhillsHostedSites ?? SandhillsImpervaAjax.HostedSites(${JSON.stringify(t)});`, e += "   window.sandhillsHostedSites.loadInventory();", e += " }, 500);", e += "<\/script>", e;
  }, U = `https://${$()}sandhillsinventory.com/${B}`, Q = () => {
    let e = `<link rel="stylesheet" type="text/css" href="${r.relativeResourcePath}css/sandhills-imperva-ajax.css?v=0.1.40">`;
    return e += '<div id="lds" class="lds">', e += '<div class="lds-ring"><div></div><div></div><div></div><div></div></div>', e += '<div class="lds-label">Loading Inventory...</div>', e += "</div>", e;
  }, k = (e) => {
    r.debug && console.groupCollapsed(e);
  }, j = () => {
    r.debug && console.groupEnd();
  }, l = (e, ...s) => {
    r.debug && console.debug(e, ...s);
  }, w = (e) => r.debug ? window.performance.mark(e) : void 0, v = (e, s) => r.debug ? window.performance.measure(e, s) : void 0;
  return !L() && r.forceBeta && (document.cookie = `${r.betaCookieName}=true;path=/;sameSite=LAX;Secure;`), {
    enable: i,
    loadInventory: _,
    loadLayout: J,
    analyzeResponse: R
  };
};
export {
  ne as HostedSites,
  oe as Imperva,
  re as Utilities
};
